import type { DealProductWithLocation } from "@/models/deal/deal.types";

export function sortProductIdsByLocation(
    productIds: string[],
    dealProducts: DealProductWithLocation[],
): string[] {
    const indexMap = new Map(dealProducts.map((p, i) => [p.id, i]));
    return productIds.slice().sort((a, b) => {
        const prodA = dealProducts.find((p) => p.id === a);
        const prodB = dealProducts.find((p) => p.id === b);
        if (!prodA || !prodB) return 0;
        const locationIndexA = dealProducts.findIndex(
            (p) => p.locationName === prodA.locationName,
        );
        const locationIndexB = dealProducts.findIndex(
            (p) => p.locationName === prodB.locationName,
        );
        if (locationIndexA !== locationIndexB)
            return locationIndexA - locationIndexB;
        return (indexMap.get(a) ?? 0) - (indexMap.get(b) ?? 0);
    });
}
